import { useQuery } from '@tanstack/react-query';
import { getUnits } from '../contactsRequest';

export const useUnits = () => {
  return useQuery({
    queryKey: ['units'],
    queryFn: getUnits,
  });
};
